module.exports = "../study/imgs/maps/Tokyo/S8/WaterEnvironment/Chlave/Tokyo_Chlave_MIROC5_RCP45_End.png";